module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray-ff0074cac13bf54539977abc33a451c6.png";